

import { useEffect, useRef } from "react";
import { IProduct, IColor } from "../types/types";

export const useSelectionEffects = (
  product: IProduct,
  selectedCustomizations: { [key: string]: string },
  setSelectedCustomizations: React.Dispatch<
    React.SetStateAction<{ [key: string]: string }>
  >,
  availabilityMap: Record<string, Record<string, boolean>>,
  availableColors: IColor[],
  imageList: string[],
  setCurrentImageIndex: React.Dispatch<React.SetStateAction<number>>,
  handleSelectionChange: (type: string, value: string) => void
) => {
  const isInitialRender = useRef(true);
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    const selectionsToUpdate: { [key: string]: string } = {};
    let needsUpdate = false;

    product.customization?.forEach((group) => {
      if (group.type === "Accessories") return;

      const currentSelection = selectedCustomizations[group.type];
      if (
        currentSelection &&
        !availabilityMap[group.type]?.[currentSelection]
      ) {
        needsUpdate = true;
        const fallbackOption = group.options.find(
          (opt) => availabilityMap[group.type]?.[opt.value]
        );
        if (fallbackOption) {
          selectionsToUpdate[group.type] = fallbackOption.value;
        }
      }
    });

    if (needsUpdate) {
      setSelectedCustomizations((prev) => ({ ...prev, ...selectionsToUpdate }));
    }
  }, [
    availabilityMap,
    product.customization,
    selectedCustomizations,
    setSelectedCustomizations,
  ]);
  useEffect(() => {
    const selectedColorName = selectedCustomizations["Color"];
    const currentSelections = Object.values(selectedCustomizations);

    if (selectedColorName) {
      const selectedColor = availableColors.find(
        (c) => c.name === selectedColorName
      );

      if (selectedColor) {
        const isSelectedColorCurrentlyOutOfStock =
          selectedColor.inStockFor &&
          selectedColor.inStockFor.length > 0 &&
          !currentSelections.some((sel) =>
            selectedColor.inStockFor.includes(sel)
          );

        if (isSelectedColorCurrentlyOutOfStock) {
          const fallbackColor = availableColors.find((color) => {
            if (!color.inStockFor || color.inStockFor.length === 0) return true;
            return currentSelections.some((sel) =>
              color.inStockFor.includes(sel)
            );
          });
          if (fallbackColor) {
            handleSelectionChange("Color", fallbackColor.name);
          }
        }
      } else {
        const fallbackColor = availableColors.find((color) => {
          if (!color.inStockFor || color.inStockFor.length === 0) return true;
          return currentSelections.some((sel) =>
            color.inStockFor.includes(sel)
          );
        });
        if (fallbackColor) {
          handleSelectionChange("Color", fallbackColor.name);
        }
      }
    }
  }, [availableColors, selectedCustomizations, handleSelectionChange]);
  useEffect(() => {
    setCurrentImageIndex(0);
  }, [imageList, setCurrentImageIndex]);
};
